import { createContext, useContext } from "react";
import { IState } from "../types";
import { initialState } from "./Action";

export const StateContext = createContext<IState>(initialState);
export const DispatchContext = createContext<Function>(()=>0);

export function useStateContext() {
    const context = useContext(StateContext);

    if (context===undefined) {
        throw new Error("useStateContext must be used inside Provider");
    }

    return context;
}

export function useDispatchContext() {
    const context = useContext(DispatchContext);

    if (context === undefined) {
        throw new Error("useDispatchContext must be used inside Provider");
    }

    return context;
}